import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./about-birth.scss";

const AboutBirth = () => {
  return (
    <section className="about-birth">
      <Fade direction="up" duration={900} triggerOnce>
        <IntroSectionBadge
          title={"Nascita di Rotoinfissioni SRL (2015)"}
          text={`È in questo periodo che i membri delle Costruzioni Generali Violato Ivano decidono di costituire la nuova "Rotoinfissioni srl", portando con sé quasi 20 anni di esperienza del Sign. Violato Ivano e credendo nelle capacità della nuova giovane forza lavoro.`}
          icon={"champagne-glasses"}
          boxIcon="primary"
          bgColor={"dark"}
        />
      </Fade>
      <Fade
        cascade
        direction="up"
        duration={1000}
        delay={200}
        damping={0.25}
        triggerOnce
      >
        <div className="about-birth__cards-list">
          <CardDefault type={"dark-grey"} width="full-width">
            <IconDescription
              icon={"house"}
              title={"Residenziale"}
              text={"Ville, condomini e complessi abitativi"}
              type={"primary"}
              size={"medium"}
              direction="vertical"
              color="dark"
            />
          </CardDefault>
          <CardDefault type={"dark-grey"} width="full-width">
            <IconDescription
              icon={"building"}
              title={"Commerciale"}
              text={"Centri commerciali e uffici"}
              type={"primary"}
              size={"medium"}
              direction="vertical"
              color="dark"
            />
          </CardDefault>
          <CardDefault type={"dark-grey"} width="full-width">
            <IconDescription
              icon={"industry"}
              title={"Industriale"}
              text={"Capannoni e impianti produttivi"}
              type={"primary"}
              size={"medium"}
              direction="vertical"
              color="dark"
            />
          </CardDefault>
          <CardDefault type={"dark-grey"} width="full-width">
            <IconDescription
              icon={"road"}
              title={"Infrastrutture"}
              text={"Ponti, strade e opere pubbliche"}
              type={"primary"}
              size={"medium"}
              direction="vertical"
              color="dark"
            />
          </CardDefault>
        </div>
      </Fade>
    </section>
  );
};

export default AboutBirth;
